export let DarkOutlineAlertdata = [
  { color: "secondary", text: "This is a secondary alert—check it out!" },
  { color: "success", text: "This is a success alert—check it out!" },
  { color: "info", text: "This is a info alert—check it out!" },
  { color: "warning", text: "This is a warning alert—check it out!" },
  { color: "danger", text: "This is a danger alert—check it out!" },
  { color: "light", text: "This is a light alert—check it out!" },
  { color: "dark", text: "This is a dark alert—check it out!" },
];
export let lightLinkColorData = [
  {
    color: "secondary",
    text: "This is a secondary alert with",
    example: "an example link",
  },
  {
    color: "success",
    text: "This is a success alert with",
    example: "an example link",
  },
  {
    color: "info",
    text: "This is a info alert with",
    example: "an example link",
  },
  {
    color: "warning",
    text: "This is a warning alert with",
    example: "an example link",
  },
  {
    color: "danger",
    text: "This is a danger alert with",
    example: "an example link",
  },
  {
    color: "light",
    text: "This is a light alert with",
    example: "an example link",
  },
  {
    color: "dark",
    text: "This is a dark alert with",
    example: "an example link",
  },
];
export  let LightAlertdata = [
  { color: "secondary", text: "This is a light alert—check it out!" },
  { color: "success", text: "This is a success alert—check it out!" },
  { color: "info", text: "This is a info alert—check it out!" },
  { color: "warning", text: "This is a warning alert—check it out!" },
  { color: "danger", text: "This is a danger alert—check it out!" },
  { color: "light", text: "This is a light alert—check it out!" },
  { color: "dark", text: "This is a dark alert—check it out!" },
];
export let LinkColorsdata = [
  {
    color: "secondary",
    text: "This is a secondary alert with",
    link: "an example link",
    click: ".Click It",
  },
  {
    color: "success",
    text: "This is a success alert with",
    link: "an example link",
    click: ".Click It",
  },
  {
    color: "info",
    text: "This is a info alert with",
    link: "an example link",
    click: ".Click It",
  },
  {
    color: "warning",
    text: "This is a warning alert with",
    link: "an example link",
    click: ".Click It",
  },
  {
    color: "danger",
    text: "This is a warning alert with",
    link: "an example link",
    click: ".Click It",
  },
  {
    color: "light",
    text: "This is a warning alert with",
    link: "an example link",
    click: ".Click It",
  },
  {
    color: "dark",
    text: "This is a dark alert with",
    link: "an example link",
    click: ".Click It",
  },
];
export  let OutlineAlertData = [
  { color: "secondary", text: " This is a info alert—check it out!" },
  { color: "success", text: " This is a info alert—check it out!" },
  { color: "info", text: " This is a info alert—check it out!" },
  { color: "warning", text: " This is a warning alert—check it out!" },
  { color: "danger", text: " This is a danger alert—check it out!" },
  { color: "light", text: " This is a light alert—check it out!" },
  { color: "dark", text: " This is a dark alert—check it out!" },
];
export let AditionalData = [
    {
      paragraphOne: ` Aww yeah, you successfully read this important alert message.
                    This example text is going to run a bit longer so that you can
                    see how spacing within an alert works with this kind of
                    content.`,
      paragraphTwo: ` Whenever you need to, be sure to use margin utilities to keep
                    things nice and tidy.`,
      color: "secondary",
    },
    {
      paragraphOne: ` Aww yeah, you successfully read this important alert message.
                    This example text is going to run a bit longer so that you can
                    see how spacing within an alert works with this kind of
                    content.`,
      paragraphTwo: ` Whenever you need to, be sure to use margin utilities to keep
                    things nice and tidy.`,
      color: "success",
    },
    {
      paragraphOne: ` Aww yeah, you successfully read this important alert message.
                    This example text is going to run a bit longer so that you can
                    see how spacing within an alert works with this kind of
                    content.`,
      paragraphTwo: ` Whenever you need to, be sure to use margin utilities to keep
                    things nice and tidy.`,
      color: "danger",
    },
    {
      paragraphOne: ` Aww yeah, you successfully read this important alert message.
                    This example text is going to run a bit longer so that you can
                    see how spacing within an alert works with this kind of
                    content.`,
      paragraphTwo: ` Whenever you need to, be sure to use margin utilities to keep
                    things nice and tidy.`,
      color: "info",
    },
    {
      paragraphOne: ` Aww yeah, you successfully read this important alert message.
                    This example text is going to run a bit longer so that you can
                    see how spacing within an alert works with this kind of
                    content.`,
      paragraphTwo: ` Whenever you need to, be sure to use margin utilities to keep
                    things nice and tidy.`,
      color: "light",
    },
    {
      paragraphOne: ` Aww yeah, you successfully read this important alert message.
                    This example text is going to run a bit longer so that you can
                    see how spacing within an alert works with this kind of
                    content.`,
      paragraphTwo: ` Whenever you need to, be sure to use margin utilities to keep
                    things nice and tidy.`,
      color: "dark",
    },
  ];
  